'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeTheme(injectedTheme) {
    return function (BaseComponent) {
        var Themed = (0, _withProps2.default)(function (ownProps) {
            var theme = injectedTheme;
            if (ownProps && ownProps.theme) {
                var ownTheme = ownProps.theme;
                theme = Object.keys(ownTheme).filter(function (key) {
                    return !!injectedTheme[key];
                }).reduce(function (accum, key) {
                    accum[key] = (0, _classnames2.default)(ownTheme[key], injectedTheme[key]);
                    return accum;
                }, _extends({}, ownTheme, injectedTheme));
            }
            return { theme: theme };
        })(BaseComponent);
        (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'themed'))(Themed);
        return Themed;
    };
}

exports.default = mergeTheme;


//////////////////
// WEBPACK FOOTER
// ./~/merge-theme-hoc/dist/index.js
// module id = 288
// module chunks = 4 5 8 9 14